import { IApplicationState } from '../../types/redux';
import { ICoordinates } from '../../types/geo';

export function getGeoCoordinates(state: IApplicationState): ICoordinates | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.coordinates && !!geo.coordinates.lng && !!geo.coordinates.lat) {
    return geo.coordinates as ICoordinates;
  }

  return null;
}
